import {
  ISalesCategoryModel,
  SalesCategoryModel,
} from '@common/models/SalesCategoryModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceMethodOptions } from '@common/services';

export class SalesCategoryService {
  private static baseUrl: string = '/api/salescategory';

  static tags = {
    getSalesCategories: 'getSalesCategories',
    getSalesCategory: 'getSalesCategory',
    updateSalesCategory: 'updateSalesCategory',
    deleteSalesCategory: 'deleteSalesCategory',
  };

  static getSalesCategories = (
    options?: ServiceMethodOptions,
  ): Promise<SalesCategoryModel[]> => {
    return trackPromise(
      new Promise<ISalesCategoryModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/listing`)
          .get<ISalesCategoryModel[]>()
          .then((response) => response.map((sc) => new SalesCategoryModel(sc)))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.getSalesCategories,
    );
  };

  static getSalesCategory = (
    salesCategoryId: number,
    options?: ServiceMethodOptions,
  ): Promise<SalesCategoryModel> => {
    return trackPromise(
      new Promise<ISalesCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}/${salesCategoryId}`)
          .get<ISalesCategoryModel>()
          .then((response) => new SalesCategoryModel(response))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.getSalesCategory,
    );
  };

  static upsertSalesCategory = (
    data: ISalesCategoryModel,
    options?: ServiceMethodOptions,
  ): Promise<SalesCategoryModel> => {
    return trackPromise(
      new Promise<ISalesCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ISalesCategoryModel>(data)
          .then((response) => new SalesCategoryModel(response))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.updateSalesCategory,
    );
  };

  static deleteSalesCategory = (
    SalesCategoryId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${SalesCategoryId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.deleteSalesCategory,
    );
  };
}
